import { createFeatureSelector } from '@ngrx/store';
import * as fromDashboard from '../states';
import createAppsSelectors from './apps';
import createCarriersSelectors from './carriers';
import createGeneralSelectors from './general';
import createSpecialFeaturesSelectors from './special-features';
import createExceptionsSelectors from './exceptions';
import createRangeSelectors from './range';

const dashboardFeatureSelector = createFeatureSelector<fromDashboard.IState, fromDashboard.IDashboardState>(
  fromDashboard.featureKey,
);

const generalSelectors = createGeneralSelectors(dashboardFeatureSelector);
const specialFeaturesSelectors = createSpecialFeaturesSelectors(dashboardFeatureSelector);
const exceptionsSelectors = createExceptionsSelectors(dashboardFeatureSelector);
const appsSelectors = createAppsSelectors(dashboardFeatureSelector);
const carriersSelectors = createCarriersSelectors(dashboardFeatureSelector);
const rangeSelectors = createRangeSelectors(dashboardFeatureSelector);

const toggleFieldToSelector = {
  isShelfReportActive: specialFeaturesSelectors.selectIsShelfReportActive,
  isScanOrdersActive: specialFeaturesSelectors.selectIsScanOrdersActive,
  lateCarrierSlaOrders: specialFeaturesSelectors.selectLateCarrierSlaOrders,
  lateDeliveryPromiseOrders: specialFeaturesSelectors.selectLateDeliveryPromiseOrders,
  isCheckoutAppActive: appsSelectors.selectIsCheckoutAppActive,
  isSlackWebhookActive: appsSelectors.selectIsSlackWebhookActive,
};

function getToggleSelectorFromFieldName(fieldName: string) {
  return toggleFieldToSelector[fieldName];
}

export {
  dashboardFeatureSelector,
  generalSelectors,
  exceptionsSelectors,
  specialFeaturesSelectors,
  appsSelectors,
  carriersSelectors,
  rangeSelectors,
  getToggleSelectorFromFieldName,
};
